import { Outlet, createRootRoute, useLocation } from "@tanstack/react-router";
import { useCallback, useRef } from "react";
import { PwaInstallHandle } from "../components";
import { ProtectedRoute } from "../components/auth";
import { AuthProvider } from "../components/auth/AuthProvider";
import { AppShell } from "../components/layout";
import PwaInstall from "../components/PwaInstall";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();
  const isAuthPage = [
    "/login",
    "/forgot-password",
    "/first-time-login",
  ].includes(location.pathname);

  const pwaInstallRef = useRef<PwaInstallHandle>(null);

  const handleInstallSuccess = useCallback((event: CustomEvent) => {
    console.log("PWA installed successfully!", event.detail);
  }, []);

  const handleInstallFail = useCallback((event: CustomEvent) => {
    console.log("PWA installation failed.", event.detail);
  }, []);

  const handleInstallAvailable = useCallback((event: CustomEvent) => {
    console.log("PWA is available for installation.", event.detail);
  }, []);

  const handleUserChoiceResult = useCallback((event: CustomEvent) => {
    console.log("User choice result:", event);
  }, []);

  if (isAuthPage) {
    return (
      <>
        <Outlet />
        {/* <TanStackRouterDevtools position="bottom-right" /> */}
      </>
    );
  }

  return (
    <AuthProvider>
      <ProtectedRoute>
        <AppShell>
          <PwaInstall
            ref={pwaInstallRef}
            manualChrome={true}
            manualApple={true}
            onInstallSuccess={handleInstallSuccess}
            onInstallFail={handleInstallFail}
            onInstallAvailable={handleInstallAvailable}
            onUserChoiceResult={handleUserChoiceResult}
          />
          <Outlet />
          {/* <TanStackRouterDevtools position="bottom-right" /> */}
        </AppShell>
      </ProtectedRoute>
    </AuthProvider>
  );
}
